import { render } from "./PotentialPartnersLinkGenerator.vue?vue&type=template&id=5a12dd1a"
import script from "./PotentialPartnersLinkGenerator.vue?vue&type=script&lang=js"
export * from "./PotentialPartnersLinkGenerator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__